module.exports = function getResource(label, vars = []) {
    let resources = {
        seeProductDetails: 'See product details',
        appExclusive: 'Download or open the Sephora app to purchase.',
        notRated: 'Not rated',
        oneReview: '1 review',
        reviews: ' reviews',
        productPreview: 'Product preview',
        viewDetails: 'View Details'
    };

    return resources[label];
};
